import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const adminEnvironmentGuard: CanActivateFn = (route, state) => {
  const production = environment.production;
  const router = inject(Router);

  if (!production) {
    return true;
  }

  router.navigate(['/admin/users']);
  return false;
};
